import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface SnackAlertProps {
  snack: any;
  setSnackAlert: any;
  children: React.ReactNode;
}

const SnackAlert: React.FC<SnackAlertProps> = ({ snack, setSnackAlert, children }) => {
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
    const newSnack = { open: false, message: '', severity: 'success' };
    setSnackAlert(newSnack);
  };
  React.useEffect(() => {
    if (snack.open) {
      setSnackBarOpen(true);
    } else {
      setSnackBarOpen(false);
    }
  }, [snack]);

  return (
    <>
      {children}
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: 8,
            borderRadius: 3,
          },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={snack.severity || 'success'}
          sx={{
            width: '100%',
            minWidth: { xs: 320, sm: 440 },
            fontSize: '1rem',
            py: 2,
            px: 2.5,
            borderRadius: 3,
            alignItems: 'center',
            '& .MuiAlert-icon': {
              fontSize: 26,
              mr: 1.5,
            },
            '& .MuiAlert-message': {
              fontWeight: 600,
              lineHeight: 1.5,
            },
          }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SnackAlert;
